import Box from "@mui/material/Box";
import Grid from "@mui/material/Unstable_Grid2";

// import { CONFIG } from 'src/config-global';
import {
  _bankingContacts,
  _bankingCreditCard,
  _bankingRecentTransitions,
} from "./_mock";

import { Iconify } from "./components/iconify";
import { BankingContacts } from "./sections/banking-contacts";
import { BankingOverview } from "./sections/banking-overview";
import { BankingInviteFriends } from "./sections/banking-invite-friends";
import { BankingQuickTransfer } from "./sections/banking-quick-transfer";
import { BankingCurrentBalance } from "./sections/banking-current-balance";
import { BankingBalanceStatistics } from "./sections/banking-balance-statistics";
import { BankingRecentTransitions } from "./sections/banking-recent-transitions";
import { BankingExpensesCategories } from "./sections/banking-expenses-categories";
import { MUI_MINIMAL_THEME_IMAGES_DIR } from "../../constants/constants";
import { QuickOrdersVIew } from "./sections/QuickOrdersVIew";
import { IStoreState, useAppDispatch, useAppSelector } from "../../redux";
import React from "react";
import { fetchDashboardExpenseCatgoriesAsync } from "../../redux/analytics/analytics.actions";
import { ExpenseCategories } from "./sections/ExpenseCategories";
import { useOutletContext } from "../../providers";
import { StandardCard } from "../../Components/Card";
import { useTheme } from "@mui/material/styles";
import { Button, Typography } from "@mui/material";
import { QrCodeDialog } from "./components/QrCodeDialog";

// ----------------------------------------------------------------------

export function DashboardV2() {
  const { OUTLET_CURRENCY_SYMBOL } = useOutletContext();
  const { outlet_details } = useOutletContext();
  const [openQrDialog, setOpenQrDialog] = React.useState(false);
  const theme = useTheme();
  const isLightMode = theme.palette.mode === "light";

  console.log("company outlet ===>", outlet_details);

  return (
    <>
      <StandardCard
        sx={
          {
            // display: "flex",
            // alignItems: "center",
            // justifyContent: "space-between",
          }
        }
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography sx={{ fontSize: "2.25rem", fontWeight: 600 }}>
            {outlet_details?.outlet_name}
          </Typography>

          <Button
            size="large"
            // color="inherit"
            sx={{
              backgroundColor: isLightMode ? "var(--secondary-color)" : "var(--primary-color)",
              color: isLightMode ? "var(--text-light-color)" : "var(--text-dark-color)",
              border: isLightMode ? "var(--border-light-color) 1px solid" : "var(--border-dark-color) 1px solid",

              "&:hover": {
                backgroundColor: isLightMode ? "var(--secondary-color)" : "var(--tertiary-color)",
                opacity: isLightMode ? 0.85 : 1,
                // color: isLightMode ? "var(--primary-color)" : "var(--secondary-color)",
                border: isLightMode ? "var(--border-light-color) 1px solid" : "var(--border-dark-color) 1px solid",
              }
            }}
            startIcon={<Iconify icon="mdi:qrcode" width={16} />}
            onClick={() => setOpenQrDialog(true)}
          >
            Generate QR Code
          </Button>
        </Box>
      </StandardCard>
      <Grid container sx={{ mt: 3, mb: 2 }} spacing={3}>
        <Grid xs={12} md={7} lg={8}>
          <Box sx={{ gap: 3, display: "flex", flexDirection: "column" }}>
            <BankingOverview sx={{ color: "inherit" }} />
            <ExpenseCategories />
            <BankingRecentTransitions
              title="Recent transitions"
              // sx={{  boxShadow: "rgba(90, 114, 123, 0.11) 0px 7px 30px 0px",}}
              tableData={_bankingRecentTransitions}
              // headLabel={[
              //   { id: 'description', label: 'Description' },
              //   { id: 'date', label: 'Date' },
              //   { id: 'amount', label: 'Amount' },
              //   { id: 'status', label: 'Status' },
              //   { id: '' },
              // ]}
            />
          </Box>
        </Grid>
        <Grid xs={12} md={5} lg={4}>
          <Box sx={{ gap: 3, display: "flex", flexDirection: "column" }}>
            <QuickOrdersVIew />
            <BankingContacts
              title="Users"
              // subheader="You have 122 contacts"
              list={_bankingContacts.slice(-5)}
              sx={{ boxShadow: "rgba(90, 114, 123, 0.11) 0px 7px 30px 0px" }}
            />

            <BankingInviteFriends
              price={`${OUTLET_CURRENCY_SYMBOL}50`}
              title={`Invite friends \n and earn`}
              sx={{ boxShadow: "rgba(90, 114, 123, 0.11) 0px 7px 30px 0px" }}
              description="Praesent egestas tristique nibh. Duis lobortis massa imperdiet quam."
              // imgUrl={`/assets/illustrations/illustration-receipt.webp`}
              imgUrl={`${MUI_MINIMAL_THEME_IMAGES_DIR}/assets/illustrations/illustration-receipt.webp`}
            />
          </Box>
        </Grid>
      </Grid>
      <QrCodeDialog
        open={openQrDialog}
        onClose={() => setOpenQrDialog(false)}
      />
    </>
  );
}
